import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "px-6 py-4 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  class: "px-6 py-4 overflow-y-auto flex-1",
  style: {"max-height":"calc(85vh - 130px)"}
}
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "border rounded p-4 bg-gray-50 min-h-[300px] overflow-auto" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "border rounded p-4 bg-gray-50 min-h-[200px] max-h-[300px] overflow-auto whitespace-pre-wrap font-mono text-sm" }
const _hoisted_9 = { class: "px-6 py-3 bg-gray-50 flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 flex items-center justify-center overflow-y-auto",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBackdropClick && _ctx.handleBackdropClick(...args))),
          onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["esc"])),
          tabindex: "-1"
        }, [
          _createElementVNode("div", {
            class: "bg-white rounded-lg shadow-xl w-11/12 max-w-4xl mx-4 my-8 overflow-hidden max-h-[85vh] flex flex-col",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            ref: "modalRef",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _ctx.titleId
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", {
                id: _ctx.titleId,
                class: "text-lg font-medium text-gray-900"
              }, _toDisplayString(_ctx.subject), 9, _hoisted_3),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500",
                "aria-label": "Close"
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("svg", {
                  class: "h-6 w-6",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-700 mb-2" }, "HTML Content", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", { innerHTML: _ctx.processedHtmlContent }, null, 8, _hoisted_7)
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-700 mb-2" }, "Text Content", -1)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.textContent), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, " Close ")
            ])
          ], 8, _hoisted_1)
        ], 32))
      : _createCommentVNode("", true)
  ]))
}